import { Link } from "react-router-dom";

const risks = [
  { num: "1", title: "Capital Risk", desc: "Investors may lose some or all of their capital. Returns are not guaranteed." },
  { num: "2", title: "Property Market Risk", desc: "The value of underlying property assets may fluctuate due to market conditions." },
  { num: "3", title: "Counterparty Risk", desc: "The housing association is responsible for rental payments. Failure to meet obligations may impact returns." },
  { num: "4", title: "Liquidity Risk", desc: "This is an illiquid investment with no secondary market. Investors should expect to hold the investment for the full term." },
  { num: "5", title: "Operational Risk", desc: "Operational issues or structural changes may impact the performance of underlying assets." },
  { num: "6", title: "Regulatory Risk", desc: "Changes in UK housing policy, taxation, or regulation may affect the investment structure or returns. Shifts in financial services regulation may also impact how the product is structured or marketed." },
  { num: "7", title: "Inflation / Interest Rate Risk", desc: "While rents may be index-linked (CPI + 1%), changes in macroeconomic conditions — including rising interest rates or sustained inflation — may still impact real returns relative to prevailing market conditions." },
];

export default function RiskSection() {
  return (
    <section className="bg-[#EEF2F9] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-[#D45B5B] text-xs font-semibold uppercase tracking-widest block mb-3">
            Important — Please Read
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#071A2E]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Risk Summary
          </h2>
          <p className="text-slate-500 text-sm mt-3 max-w-xl mx-auto">
            This investment is speculative. Investors should carefully consider all risks before proceeding and seek independent financial advice where appropriate.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {risks.map((r) => (
            <div key={r.num} className="bg-white rounded-2xl p-6 flex gap-4">
              <span
                className="text-3xl font-bold text-[#D45B5B]/20 leading-none flex-shrink-0"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {r.num}
              </span>
              <div>
                <h3 className="font-bold text-[#071A2E] text-sm mb-2">{r.title}</h3>
                <p className="text-slate-500 text-xs leading-relaxed">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#071A2E] rounded-2xl p-6 text-center">
          <p className="text-slate-300 text-xs leading-relaxed max-w-3xl mx-auto">
            Past performance is not indicative of future results. This document is intended solely for Certified High Net Worth Individuals, Self-Certified Sophisticated Investors, or eligible retail investors as defined under FSMA 2000. If you are unsure whether this investment is appropriate for you, please seek independent financial advice.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 mt-5 px-6 py-3 rounded-full bg-[#C9A84C] text-[#071A2E] text-sm font-semibold hover:bg-[#B8953B] transition-colors cursor-pointer whitespace-nowrap"
          >
            Speak to an Adviser
            <i className="ri-arrow-right-line leading-none" />
          </Link>
        </div>
      </div>
    </section>
  );
}
